<template>
  <div class="relative" data-test-id="article-card">
    <base-picture
      :alt="image.alt"
      class="w-full"
      :class="brandClasses.image"
      fit="cover"
      height="340"
      :props-img="{ class: 'aspect-square' }"
      :src="image.src"
      width="340"
    />
    <div :class="[cardContentContainer, brandClasses.card]">
      <p v-if="tags" class="line-clamp-1 flex gap-x-4 eyebrow <md:hidden">
        <span v-for="tag in tags" :key="tag">
          {{ tag }}
        </span>
      </p>
      <p :id :class="brandClasses.title" :to>
        {{ title }}
      </p>
      <p v-if="showDate && !hidePageDate && date" :class="brandClasses.date">
        {{ date }}
      </p>
      <p v-if="description" :class="brandClasses.description">
        {{ description }}
      </p>
      <base-link ref="linkRef" :aria-describedby="id" class="underlined i-block" :class="brandClasses.link" :to>
        {{ $t.readMore }}
        <span class="absolute-0" />
      </base-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string
  to: string
  image: {
    src: string
    alt?: string
  }
  tags?: string[]
  date?: string
  description?: string
  hidePageDate?: boolean
  cardContentContainer?: string
}>()

const { brandClasses, showDate } = useAppConfig().components.vf.articleCard
const id = useId()

const linkRef = useTemplateRef('linkRef')

const focus = () => {
  linkRef.value?.$el.focus({ preventScroll: true })
  linkRef.value?.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

defineExpose({ focus })
</script>
